import { draftToMarkdown } from 'markdown-draft-js'
import { buildDateTime } from 'lib/CustomLuxonUtils'
import { dollarsToCents } from 'lib/utils/number'
import { getRegistrationOpenDateTime } from 'pages/pga-coach/bookings/events/registration-open-datetime'
import {
  composeMaxAttendance,
  isOnlinePayment,
  LEGACY_ADULTS_ONLY_TAG,
  LEGACY_JUNIORS_ONLY_TAG,
  ALL_AGE_GROUP_TAGS,
  MANUAL_PAYMENT,
} from 'utils/groupEventUtils'
import { SCHEDULE_TYPE_RECURRING } from 'components/group-events/recurring-schedule/generate-occurrences'

export const buildCreateVariables = ({
  formValues,
  coachFacilityLocations,
  isRecurringInstancesEnabled,
}) => {
  const ageGroupMap = new Map([
    ['adults-only', LEGACY_ADULTS_ONLY_TAG],
    ['juniors-only', LEGACY_JUNIORS_ONLY_TAG],
  ])
  const filteredTags = formValues.tags.filter(
    tag => !ALL_AGE_GROUP_TAGS.includes(tag),
  )
  const ageGroupValue = ageGroupMap.get(formValues.ageGroup)
  if (ageGroupValue) {
    filteredTags.push(ageGroupValue)
  }
  const isHopeEvent = filteredTags.includes('PGA HOPE')

  const paymentRecurrenceSchedule = isHopeEvent
    ? MANUAL_PAYMENT
    : formValues.paymentRecurrenceSchedule
  const price = isHopeEvent ? '0' : formValues.price

  const facility = coachFacilityLocations?.find(
    cf => cf.id === formValues.locationId,
  )
  const isRecurring =
    isRecurringInstancesEnabled &&
    formValues.scheduleType === SCHEDULE_TYPE_RECURRING
  const mappedSessions = formValues.sessions.map(session => ({
    facilityId: facility.id,
    startDateTime: buildDateTime(
      session.startDate,
      session.startTime,
      facility.timezone,
    ),
    endDateTime: buildDateTime(
      session.startDate,
      session.endTime,
      facility.timezone,
    ),
  }))
  const sessions = isRecurring
    ? [...mappedSessions].sort(
      (a, b) => a.startDateTime.toMillis() - b.startDateTime.toMillis(),
    )
    : mappedSessions
  const startDateTime = sessions[0].startDateTime

  const groupEvent = {
    title: formValues.title,
    ...(formValues.academyId && { academyId: formValues.academyId }),
    academyRequired: formValues.academyRequired || !!formValues.academyId,
    assistantCoachIds: formValues.assistantCoachIds,
    description: formValues.description
      ? draftToMarkdown(JSON.parse(formValues.description))
      : null,
    registrationCloseDateTime: !formValues.isExternalRegistration
      ? startDateTime.minus({
        hours: formValues.hoursBeforeRegistrationCloses,
      })
      : null,
    registrationOpenDateTime: getRegistrationOpenDateTime(
      formValues,
      facility.timezone,
    ),
    tags: filteredTags,
    maxAttendance: composeMaxAttendance(
      formValues.maxAttendance,
      formValues.waitlistEnabled,
    ),
    unlisted: formValues.unlisted,
    priceInCents: dollarsToCents(price),
    externalRegistrationUrl: formValues.isExternalRegistration
      ? formValues.externalRegistrationUrl
      : null,
    featuredImageUrl: formValues.featuredImageUrl,
    paymentRecurrenceSchedule,
    paymentAccountId:
      isOnlinePayment({ paymentRecurrenceSchedule }) &&
      (formValues.paymentAccountId || '').length > 0
        ? formValues.paymentAccountId
        : null,
    accessCode:
      (formValues.accessCode || '').length > 0 ? formValues.accessCode : null,
    waitlistEnabled: formValues.waitlistEnabled,
    collectAttendance: formValues.collectAttendance,
    templateId: formValues.templateId || null,
  }

  if (isRecurring) {
    return {
      isRecurring,
      variables: { groupEvent, occurrences: sessions },
    }
  }

  return {
    isRecurring,
    variables: { groupEvent: { ...groupEvent, sessions } },
  }
}

export default buildCreateVariables
